import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const cloudinary = defineConnector({
  identifier: "cloudinary",
  name: "Cloudinary",
  tagLine: "Image and video management",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: () => "https://api\\.cloudinary\\.com/.*",
  auth: (app) =>
    basicAuth({
      username: app.secret.apiKey,
      password: app.secret.apiSecret,
    }),
  steps: [
    {
      title: "Get your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In the [Cloudinary console](https://console.cloudinary.com/), open **Settings › API Keys** and copy your cloud name, API key, and API secret.",
        },
      ],
    },
    {
      title: "Enter your Cloudinary details",
      items: [
        {
          kind: "input",
          label: "Cloud name",
          required: true,
          target: { kind: "configuration", field: "cloudName" },
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
        {
          kind: "input",
          label: "API secret",
          required: true,
          target: { kind: "secrets", field: "apiSecret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ cloudName }) =>
      `https://api.cloudinary.com/v1_1/${cloudName}/usage`,
  },
});
